import {IsEnvironmentProd} from '../common/apiurl'
export const environment = {
  production: IsEnvironmentProd
};

